export default {"src":"/_next/static/media/github-mark.3b925f14.svg","height":96,"width":98,"blurWidth":0,"blurHeight":0};